"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _togaIcon = _interopRequireDefault(require("@thinkific/toga-icon"));

var _SortArrows = _interopRequireDefault(require("./SortArrows.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var cx = _bind["default"].bind(_SortArrows["default"]);

var SortArrows = function SortArrows(_ref) {
  var columnName = _ref.columnName,
      isSortDownActive = _ref.isSortDownActive,
      isSortUpActive = _ref.isSortUpActive,
      handleSortDown = _ref.handleSortDown,
      handleSortUp = _ref.handleSortUp,
      isHoveringColumn = _ref.isHoveringColumn;
  var title = isSortUpActive ? "Order ".concat(columnName, " asc") : "Order ".concat(columnName, " desc");
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: cx('sort-arrows')
  }, /*#__PURE__*/_react["default"].createElement(_togaIcon["default"], {
    className: cx('arrow-up', {
      active: isSortUpActive,
      'is-hovering-active': isSortUpActive && isHoveringColumn,
      'is-hovering': !isSortUpActive && !isSortDownActive && isHoveringColumn
    }),
    name: "arrow-up",
    title: title,
    onClick: handleSortUp
  }), /*#__PURE__*/_react["default"].createElement(_togaIcon["default"], {
    className: cx('arrow-down', {
      active: isSortDownActive,
      'is-hovering-active': isSortDownActive && isHoveringColumn
    }),
    name: "arrow-down",
    title: title,
    onClick: handleSortDown
  }));
};

SortArrows.propTypes = {
  columnName: _propTypes["default"].string,
  handleSortDown: _propTypes["default"].func,
  handleSortUp: _propTypes["default"].func,
  isHoveringColumn: _propTypes["default"].bool,
  isSortDownActive: _propTypes["default"].bool,
  isSortUpActive: _propTypes["default"].bool
};
SortArrows.defaultProps = {
  columnName: '',
  isSortDownActive: false,
  isSortUpActive: false,
  handleSortDown:
  /* istanbul ignore next */
  function handleSortDown() {},
  handleSortUp:
  /* istanbul ignore next */
  function handleSortUp() {},
  isHoveringColumn: null
};
var _default = SortArrows;
exports["default"] = _default;